export { default } from "./footer";